import { render } from "./TabPill.vue?vue&type=template&id=732bb4da"
import script from "./TabPill.vue?vue&type=script&lang=js"
export * from "./TabPill.vue?vue&type=script&lang=js"
script.render = render

export default script